import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Pager, Selection,
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import KurumPersonelDetay from "../kurumpersoneldetay/KurumPersonelDetay";
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../utils/Utils";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';


import BildirgeLoginIslemleri from "../sgklogin/BildirgeLoginIslemleri";
import './BildirgeIslemleri.scss';

const BildirgeIslemleri = () => {

    const [formYetki, setFormYetki] = useState(
        {
            sgkLogin: Utils.hasRole("bildirge|bildirgeislemleri|sgkLogin"),
            donemIndir: Utils.hasRole("bildirge|bildirgeislemleri|donemIndir"),
            muhtasarDonemIndir: Utils.hasRole("bildirge|bildirgeislemleri|muhtasarDonemIndir"),
            bildirgeDetay: Utils.hasRole("bildirge|bildirgeDetay|listele"),
        });


    const listeBasligi = "Bildirge İşlemleri";

    const [loginInfo, setLoginInfo] = useState({});
    // const [loginPopupState, setLoginPopupState] = useState(false);
    const [personelDetayData, setPersonelDetayData] = useState({ popupState: false, data: {} });
    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [store, setStore] = useState(null);
    const [bildirgeDetayData, setBildirgeDetayData] = useState({ popupState: false, data: {} });
    const [filterMap, setFilterMap] = useState(null);

    useEffect(() => {
        setFilterMap(Utils.getFilterMap(dataGrid));
    }, [])

    useEffect(() => {
        if (filterMap) {
            domainListYukle();
            setStore(getStore());
        }
    }, [filterMap])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    let dataGrid = null;
    let treeView = null;

    const getStore = () => {
        let tempGrid = dataGrid;

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                let filterArr = [];
                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "dm.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }

                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);


                if (tempGrid != null && tempGrid.instance != null) {
                    tempGrid.instance.clearSelection();
                }

                const request = new Request("/bildirgeIslemleri/getKayitList" + params, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }


    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const yenile = () => {
        setStore(getStore());
    }


    // function hideLoginPopupInfo() {
    //     setLoginPopupState(false);
    // }

    function hidePersonelListesiPopup() {
        setPersonelDetayData({ popupState: false, data: {} })
    }

    // function textValueChanged(data) {
    //     loginInfo.name = data.value;
    //     setLoginInfo(loginInfo)
    // }

    // function login(domainId) {

    //     if (loginInfo == null || loginInfo.name == null || loginInfo.name == '') {
    //         const request = new Request("/bildirgeIslemleri/getGuvenlikKodFile/" + domainId, "GET");
    //         request.run()
    //             .then(response => {
    //                 if (response.data && response.data != null) {
    //                     response.data.data = "data:image/jpeg;base64," + response.data.data;
    //                     setLoginInfo({file: response.data.data, name: '', domainId: domainId})
    //                     setLoginPopupState(true);
    //                 }
    //             });
    //     } else {
    //         const request = new Request("/bildirgeIslemleri/login/" + loginInfo.domainId + "/" + loginInfo.name, "GET");
    //         request.run()
    //             .then(response => {
    //                 if (response.data && response.data.data === true) {
    //                     setLoginPopupState(false);
    //                 }
    //                 //loginInfo.name ='';
    //                 setLoginInfo(Object.assign({}, loginInfo, {name: ''}));
    //             });

    //     }

    // }

    // function refreshLoginImage() {
    //     let domainId = loginInfo.domainId;
    //     const request = new Request("/bildirgeIslemleri/reloadGuvenlikKodFile/" + domainId, "GET");
    //     request.run()
    //         .then(response => {
    //             if (response.data && response.data != null) {
    //                 response.data.data = "data:image/jpeg;base64," + response.data.data;
    //                 setLoginInfo({file: response.data.data, name: '', domainId: domainId})
    //             }
    //         });
    // }

    function donemIndir(data) {
        let propData = getBildirgeDetayDataInfo();
        if (propData.success == true) {
            showBildirgeIslemleriPopup(propData);
        }
    }

    function hideBildirgeIslemleriPopup() {
        setBildirgeDetayData({ popupState: false, data: {} })
        yenile();
    }
    function showBildirgeIslemleriPopup(data) {
        setBildirgeDetayData({
            popupState: true,
            data: data
        });
    }



    function getBildirgeDetayDataInfo() {
        let tempGrid = dataGrid;

        let propData = {
            domainIdList: [],
            domainAdiList: [],
            donemIdList: [],
            donemAdiList: [],
            domainId: null,
            domainAdi: null
        }
        tempGrid.instance.getSelectedRowsData().map(sd => {
            if (propData.domainIdList.indexOf(sd.domainId) == -1) {
                propData.domainIdList.push(sd.domainId);
                propData.domainAdiList.push(sd.domain);

            }
            propData.donemIdList.push(sd.donemId);
            propData.donemAdiList.push(sd.donem);
        });

        if (propData.domainIdList.length == 0) {
            //showToast("Kayıt seçiniz", ToastType.ERROR, 1000);
            propData.success = false;
        } else if (propData.domainIdList.length > 1) {
            //showToast("Seçilen kayıtlar aynı firmaya at olması gerekir", ToastType.ERROR, 1000);
            propData.success = false;
        } else {
            propData.domainId = propData.domainIdList[0];
            propData.domainAdi = propData.domainAdiList[0];
            propData.success = true;
        }
        return propData;
    }



    function personelListesiGoster(data) {
        setPersonelDetayData({
            popupState: true,
            data: {
                donemId: data.donemId,
                domainId: data.domainId
            }
        });
    }


    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                </div>
            </div>

            <DataGrid
                className="bildirgeGrid"
                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                remoteOperations={true}
            >
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={24} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[12, 24, 36, 48, 60, 100, 200]} showInfo={true}  visible={true}/>
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />
               
                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        {
                            hint: 'Bilgirde İndir', icon: 'download',
                            visible: () => { return formYetki.sgkLogin && (formYetki.donemIndir || formYetki.muhtasarDonemIndir) },
                            onClick: (e) => {
                                donemIndir(e.row.data);
                            }
                        },
                        {
                            hint: 'Personel Listesi', icon: 'user',
                            visible: () => { return formYetki.bildirgeDetay },
                            onClick: (e) => {
                                personelListesiGoster(e.row.data);
                            }
                        },
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="nuber" visible={false} mappingField="dm.id" />
                <Column dataField={'domain'} width={450} caption={'Domain'} dataType="string" visible={true} mappingField="dm.name" />
                <Column dataField="donem" width={90} caption={'Dönem'} dataType="string" visible={true}
                    defaultSortOrder="desc"
                    mappingField="dn.donem"
                />
                <Column dataField={'toplamCalisanSayisi'} width={90} caption={'Çalışan Sayı'} dataType="number" mappingType="int" visible={true} />

                <Column dataField={'aktarildi'} width={90} caption={'Aktarılan Belge'} dataType="number" mappingType="int" visible={true} />
                <Column dataField={'kanun'} width={200} caption={'Kanun'} dataType="string" visible={true} />
                

            </DataGrid>


            <Popup
                visible={bildirgeDetayData.popupState}
                onHiding={hideBildirgeIslemleriPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Sgk Dönem işlemleri"
                width={300}
                height={300}
            >
                <div>
                    {bildirgeDetayData.popupState ? <BildirgeLoginIslemleri data={bildirgeDetayData.data} hide={hideBildirgeIslemleriPopup} /> : null}
                </div>
            </Popup>

            {/* <Popup
                visible={loginPopupState}
                onHiding={hideLoginPopupInfo}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Güvenlik Sorusu Doğrulama"
                width={300}
                height={250}
            >
                <div>
                    <img src={loginInfo.file}/>
                    <br></br>
                    <Button id="refreshButton" icon="refresh" text="Yenile" onClick={refreshLoginImage}/>
                    <TextBox valueChangeEvent="keyup" onValueChanged={textValueChanged}/>
                    <Button
                        width={300}
                        text="Giriş"
                        type="normal"
                        stylingMode="outlined"
                        onClick={login}
                    />
                </div>

            </Popup> */}

            <Popup
                visible={personelDetayData.popupState}
                onHiding={hidePersonelListesiPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Personel Listesi"
                width={800}
                height={600}
            >
                <div>

                    {personelDetayData.popupState ? <KurumPersonelDetay data={personelDetayData.data} gridClassName="peronelPopupGrid" /> : null}


                    <Button
                        width={800}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hidePersonelListesiPopup}
                    />
                </div>
            </Popup>


        </React.Fragment>
    );
}

export default BildirgeIslemleri;
